// Google Analytics Event Tracking Utility

// Page View tracking
export const trackPageView = (path) => {
  window.gtag('event', 'page_view', {
    page_path: path,
  });
};

// User Authentication Events
export const trackAuthEvent = (action, method) => {
  window.gtag('event', action, {
    event_category: 'Authentication',
    method: method,
  });
};

// Content Generation Events
export const trackContentGeneration = (contentType, success) => {
  window.gtag('event', 'generate_content', {
    event_category: 'Content',
    content_type: contentType,
    success: success,
  });
};

// Subscription Events
export const trackSubscription = (plan, value) => {
  window.gtag('event', 'purchase', {
    event_category: 'Subscription',
    items: [{
      item_name: plan,
      price: value
    }],
    value: value,
    currency: 'USD'
  });
};

// Blog Post Events
export const trackPostAction = (action, postId) => {
  window.gtag('event', action, {
    event_category: 'Posts',
    post_id: postId,
  });
};

// Setup Wizard Events
export const trackSetupProgress = (step, completed) => {
  window.gtag('event', 'setup_progress', {
    event_category: 'Onboarding',
    step: step,
    completed: completed,
  });
};

// Error Tracking
export const trackError = (errorType, errorMessage) => {
  window.gtag('event', 'error', {
    event_category: 'Error',
    error_type: errorType,
    error_message: errorMessage,
  });
}; 